
import Vue from "vue";
import { setAccessToken } from "@/api";
import { Website } from "@/models";
import { putWebsiteInCompany, getWebsiteByCompanyId } from "@/api/websites-new";
import { EnterpriseAdapterApi } from "@vacancorp/enterprise.adapter.api.vacanservice.com";

import TheTemplate from "../TheNoSidebarTemplate.vue";
import BaseCloseButton from "@/components/BaseCloseButton.vue";
import WebsiteEditor from "./components/WebsiteEditor.vue";

export type DataType = {
  website?: Website;
};

export default Vue.extend({
  name: "WebsiteDetailScreen",

  components: {
    TheTemplate,
    BaseCloseButton,
    WebsiteEditor,
  },

  data(): DataType {
    return {
      website: undefined,
    };
  },

  mounted(): void {
    this.getWebsite();
  },

  methods: {
    async getWebsite(): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      const websiteId = this.$router.currentRoute.params.websiteId;
      setAccessToken(this.$auth.accessToken);

      const response = await getWebsiteByCompanyId(companyId, websiteId);
      this.website = response;
    },

    async updateWebsite(
      website: EnterpriseAdapterApi.RequestPutWebsite
    ): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      this.$setLoading(true);

      const websiteId = this.$router.currentRoute.params.websiteId;
      setAccessToken(this.$auth.accessToken);

      await putWebsiteInCompany(companyId, websiteId, website);

      this.$setLoading(false);
      this.$setChecked(true);
      this.$afterSuccessRequest(() => {
        this.$router.push({
          name: `company-websites`,
          params: {
            updated: "true",
          },
        });
      }, 2);
    },

    afterLeave(): void {
      this.$setChecked(false);
    },
  },
});
